module.exports = __webpack_public_path__ + "static/img/preview-64px.5aed7315.png";